import { createTypedEnum } from '@reckon-web/formschema-enums';

export const NotificationCategoriesEnum = createTypedEnum({
  Job: 'Job',
  Task: 'Task',
  Mention: 'Mention',
} as const);
export type NotificationCategoriesValueType =
  (typeof NotificationCategoriesEnum.values)[number];
export type NotificationCategoriesLabelType =
  (typeof NotificationCategoriesEnum.labels)[number];
